var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBreakB2C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 529.7 523.9",
    style: {
      enableBackground: "new 0 0 529.7 523.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FCF8AC;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264.9,
    cy: 261.9,
    r: 238.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.9,294.2c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v90.8 C386.9,293.8,386.4,294.2,385.9,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.1,294.2c-0.3,0-0.7-0.2-0.8-0.5l-41.6-83.2c-0.2-0.5,0-1,0.4-1.3c0.5-0.2,1,0,1.3,0.4l41.6,83.2 c0.2,0.5,0,1-0.4,1.2C295.4,294.2,295.3,294.2,295.1,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.6,294.2c-0.3,0-0.7-0.2-0.8-0.5L248.9,218c-0.2-0.5,0-1,0.4-1.2c0.5-0.2,1,0,1.2,0.4l37.8,75.7 c0.2,0.5,0,1-0.4,1.2C287.9,294.2,287.7,294.2,287.6,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.7,286.6c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c12,0,21.8-9.8,21.8-21.8c0-12-9.8-21.8-21.8-21.8 c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c13,0,23.6,10.6,23.6,23.6C205.3,276,194.7,286.6,181.7,286.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.7,279.1c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c7.8,0,14.2-6.4,14.2-14.2 c0-7.8-6.4-14.2-14.2-14.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c8.9,0,16.1,7.2,16.1,16.1 C197.7,271.9,190.5,279.1,181.7,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.7,271.5c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c3.7,0,6.6-3,6.6-6.6c0-3.7-3-6.6-6.6-6.6 c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c4.7,0,8.5,3.8,8.5,8.5C190.2,267.7,186.4,271.5,181.7,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.7,233.7c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c7.8,0,14.2-6.4,14.2-14.2 c0-7.8-6.4-14.2-14.2-14.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c8.9,0,16.1,7.2,16.1,16.1 C197.7,226.5,190.5,233.7,181.7,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.7,226.1c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c3.7,0,6.6-3,6.6-6.6c0-3.7-3-6.6-6.6-6.6 c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c4.7,0,8.5,3.8,8.5,8.5C190.2,222.3,186.4,226.1,181.7,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.7,294.2c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v90.8 C182.6,293.8,182.2,294.2,181.7,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.1,294.2c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v90.8 C175,293.8,174.6,294.2,174.1,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.8,294.2c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v90.8 C144.8,293.8,144.4,294.2,143.8,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.3,294.2c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v90.8 C137.2,293.8,136.8,294.2,136.3,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344.3,241.2c-0.3,0-0.7-0.2-0.8-0.5l-18.9-37.8c-0.2-0.5,0-1,0.4-1.2c0.5-0.2,1,0,1.3,0.4l18.9,37.8 c0.2,0.5,0,1-0.4,1.2C344.6,241.2,344.5,241.2,344.3,241.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.1,233.7c-0.3,0-0.7-0.2-0.8-0.5l-15.1-30.3c-0.2-0.5,0-1,0.4-1.2c0.5-0.2,1,0,1.2,0.4l15.1,30.3 c0.2,0.5,0,1-0.4,1.3C348.4,233.6,348.2,233.7,348.1,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.8,294.2c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.7-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.3l-7.6,15.1C371.5,294,371.1,294.2,370.8,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.2,294.2c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l15.1-30.3c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.3l-15.1,30.3C363.9,294,363.6,294.2,363.2,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.2,279.1c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l15.1-30.3c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-15.1,30.3C363.9,278.9,363.6,279.1,363.2,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.2,263.9c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l15.1-30.3c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-15.1,30.3C363.9,263.7,363.6,263.9,363.2,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.2,248.8c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l15.1-30.3c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-15.1,30.3C363.9,248.6,363.6,248.8,363.2,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.2,233.7c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l15.1-30.3c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-15.1,30.3C363.9,233.5,363.6,233.7,363.2,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.2,218.5c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l7.6-15.1c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C363.9,218.3,363.6,218.5,363.2,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159,294.2c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.3l-7.6,15.1C159.6,294,159.3,294.2,159,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.4,294.2c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l15.1-30.3c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.3l-15.1,30.3C152.1,294,151.8,294.2,151.4,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.4,279.1c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l15.1-30.3c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-15.1,30.3C152.1,278.9,151.8,279.1,151.4,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.4,263.9c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l15.1-30.3c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-15.1,30.3C152.1,263.7,151.8,263.9,151.4,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.4,248.8c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l15.1-30.3c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-15.1,30.3C152.1,248.6,151.8,248.8,151.4,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.4,233.7c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l15.1-30.3c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-15.1,30.3C152.1,233.5,151.8,233.7,151.4,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.4,218.5c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C152.1,218.3,151.8,218.5,151.4,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.2,256.4c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C329.9,256.2,329.5,256.4,329.2,256.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M325.4,248.8c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C326.1,248.6,325.8,248.8,325.4,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.6,241.2c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.3l-7.6,15.1C322.3,241,322,241.2,321.6,241.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317.8,233.7c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l7.6-15.1c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C318.5,233.5,318.2,233.7,317.8,233.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.1,226.1c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.3l-7.6,15.1C314.7,225.9,314.4,226.1,314.1,226.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.3,218.5c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C310.9,218.3,310.6,218.5,310.3,218.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.5,211c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l3.8-7.6c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-3.8,7.6C307.2,210.8,306.8,211,306.5,211z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246,241.2c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.3l-7.6,15.1C246.6,241,246.3,241.2,246,241.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.8,248.8c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.3l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C250.4,248.6,250.1,248.8,249.8,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.5,256.4c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C254.2,256.2,253.9,256.4,253.5,256.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.3,263.9c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C258,263.7,257.7,263.9,257.3,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.1,271.5c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.3l-7.6,15.1C261.8,271.3,261.4,271.5,261.1,271.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.9,279.1c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.7,0.8,0.4,1.3l-7.6,15.1C265.6,278.9,265.2,279.1,264.9,279.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M268.7,286.6c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-7.6,15.1C269.3,286.4,269,286.6,268.7,286.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.5,294.2c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l7.6-15.1c0.2-0.5,0.8-0.6,1.2-0.4 c0.5,0.2,0.6,0.8,0.4,1.3l-7.6,15.1C273.1,294,272.8,294.2,272.5,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280,294.2c-0.1,0-0.3,0-0.4-0.1c-0.5-0.2-0.6-0.8-0.4-1.2l3.8-7.6c0.2-0.5,0.8-0.6,1.3-0.4 c0.5,0.2,0.6,0.8,0.4,1.2l-3.8,7.6C280.7,294,280.4,294.2,280,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M151.4,294.2c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v90.8 C152.3,293.8,151.9,294.2,151.4,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.5,294.2c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v90.8 C167.5,293.8,167.1,294.2,166.5,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M363.2,294.2c-0.5,0-0.9-0.4-0.9-0.9v-86.8l-28.5,57c-0.3,0.6-1.3,0.6-1.7,0l-28.5-57v86.8 c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.4,0.3-0.8,0.7-0.9c0.4-0.1,0.9,0.1,1.1,0.5l29.4,58.9l29.4-58.9 c0.2-0.4,0.6-0.6,1.1-0.5c0.4,0.1,0.7,0.5,0.7,0.9v90.8C364.2,293.8,363.8,294.2,363.2,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.5,248.8c-0.3,0-0.7-0.2-0.8-0.5L317,202.9c-0.2-0.5,0-1,0.4-1.2c0.5-0.2,1,0,1.3,0.4l22.7,45.4 c0.2,0.5,0,1-0.4,1.3C340.8,248.8,340.7,248.8,340.5,248.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.4,294.2c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v90.8 C379.3,293.8,378.9,294.2,378.4,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.7,294.2c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c16.2,0,29.3-13.2,29.3-29.3 c0-16.2-13.2-29.3-29.3-29.3c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9c17.2,0,31.2,14,31.2,31.2 C212.9,280.2,198.9,294.2,181.7,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.7,294.2c-0.3,0-0.7-0.2-0.8-0.5l-44.6-89.1l-44.6,89.1c-0.2,0.5-0.8,0.6-1.2,0.4 c-0.5-0.2-0.6-0.8-0.4-1.2l45.4-90.8c0.3-0.6,1.3-0.6,1.7,0l45.4,90.8c0.2,0.5,0,1-0.4,1.2C303,294.2,302.9,294.2,302.7,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M272.5,294.2c-0.3,0-0.7-0.2-0.8-0.5l-30.3-60.5c-0.2-0.5,0-1,0.4-1.2c0.5-0.2,1,0,1.2,0.4l30.3,60.5 c0.2,0.5,0,1-0.4,1.2C272.7,294.2,272.6,294.2,272.5,294.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M257.3,263.9h-30.3c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h30.3c0.5,0,0.9,0.4,0.9,0.9 C258.3,263.5,257.8,263.9,257.3,263.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.8,294.2c-0.5,0-0.9-0.4-0.9-0.9v-90.8c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v90.8 C394.7,293.8,394.3,294.2,393.8,294.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.4,304.8h1.5l-8.5,8.4l9,9h-1.5l-8.3-8.3l-0.5,0.5v7.8H135v-17.4h1.1v8.1L144.4,304.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.2,316.4l-2.3,5.7h-1.1l7.3-17.9l7.3,17.9h-1.1l-2.3-5.7H160.2z M164,307l-3.4,8.4h6.8L164,307z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.2,322.1h-1.3l-5.7-8.2h-0.6v8.2h-1.1v-17.4h2.2c1.4,0,2.8,0,4,0.9c1.2,0.9,1.8,2.3,1.8,3.7 c0,3-2.1,4.6-5,4.5L192.2,322.1z M186.1,312.9c1.1,0,2.2,0,3-0.8c0.8-0.7,1.2-1.7,1.2-2.7c0-1.3-0.6-2.6-1.8-3.1 c-0.9-0.4-2.1-0.4-3.1-0.4h-0.7v7.1H186.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M206.9,316.4l-2.3,5.7h-1.1l7.3-17.9l7.3,17.9h-1.1l-2.3-5.7H206.9z M210.7,307l-3.4,8.4h6.8L210.7,307z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.3,313.4c0,4.9-4.1,8.9-9,8.9c-4.9,0-9-4-9-8.9c0-4.9,4.1-8.9,9-8.9C243.2,304.5,247.3,308.6,247.3,313.4 z M230.4,313.4c0,4.3,3.6,7.9,7.9,7.9c4.3,0,7.9-3.6,7.9-7.9c0-4.3-3.6-7.9-7.9-7.9C234,305.6,230.4,309.2,230.4,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M269.7,304.8h1.5l-8.5,8.4l9,9h-1.5l-8.3-8.3l-0.5,0.5v7.8h-1.1v-17.4h1.1v8.1L269.7,304.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.9,305.8v6.3h7v1h-7v7.9h7.2v1h-8.3v-17.4h8.3v1H284.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.4,322.1v-17.4h3.5c1.3,0,2.6,0.1,3.6,1c1.1,0.9,1.5,2.2,1.5,3.6c0,1.6-0.6,2.8-2,3.5 c2.1,0.4,3.6,2.2,3.6,4.4c0,1.4-0.5,2.7-1.6,3.6c-1.2,1-2.5,1.2-4.1,1.2H330.4z M331.5,312.6h1.9c1.2,0,2.1,0.1,3.1-0.6 c1-0.7,1.3-1.6,1.3-2.8c0-1.1-0.4-2.2-1.4-2.9c-0.9-0.6-2-0.6-3-0.6h-1.9V312.6z M331.5,321.1h2.6c1.2,0,2.5,0,3.5-0.7 c1.1-0.7,1.7-1.8,1.7-3.1c0-1.3-0.6-2.5-1.8-3.1c-1.1-0.5-2.5-0.6-3.7-0.6h-2.4V321.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M371.5,313.4c0,4.9-4.1,8.9-9,8.9c-4.9,0-9-4-9-8.9c0-4.9,4.1-8.9,9-8.9C367.4,304.5,371.5,308.6,371.5,313.4 z M354.6,313.4c0,4.3,3.6,7.9,7.9,7.9c4.3,0,7.9-3.6,7.9-7.9c0-4.3-3.6-7.9-7.9-7.9C358.1,305.6,354.6,309.2,354.6,313.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.8,304.8h1.2l4,7.5l4-7.5h1.2l-4.5,8.5l4.8,8.9h-1.2l-4.2-7.9l-4.2,7.9h-1.2l4.7-8.9L383.8,304.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBreakB2C);
export default __webpack_public_path__ + "static/media/logo-break-b2c.3f313307883b528d2c52de2be2738358.svg";
export { ForwardRef as ReactComponent };